module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-15.1861ec65.png";